/**
 * FollowUpEditPage - Page for editing an existing follow-up
 */

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useFollowUp } from "../hooks/useFollowUps.js";
import FollowUpForm from "../components/FollowUpForm.jsx";

/**
 * FollowUpEditPage Component
 */
const FollowUpEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: followUp, isLoading, error } = useFollowUp(id);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !followUp) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          {error?.message || "Follow-up not found"}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <Box
          component="button"
          onClick={() => navigate(`/followups/${id}`)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "primary.main",
            mb: 2,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          <ArrowBack fontSize="small" />
          <Typography variant="body2">Back to Follow-up</Typography>
        </Box>
      </Box>
      <Typography variant="h5" gutterBottom>
        Edit Follow-up
      </Typography>
      <FollowUpForm
        initialData={followUp}
        onSuccess={(updatedFollowUp) => {
          navigate(`/followups/${id}`);
        }}
      />
    </Box>
  );
};

export default FollowUpEditPage;

